"use client";

import { c as _c } from "react/compiler-runtime";
import LocaleLink from "@components/LocaleLink";
import { ReactUIProvider } from "@justhome/react-ui";
import Image from "next/image";
import { FC, PropsWithChildren } from "react";
const Providers: FC<PropsWithChildren> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ReactUIProvider linkComponent={LocaleLink} imageComponent={Image}>{children}</ReactUIProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Providers;